class LegendSettings {
  constructor() {
    this.geoserver_layer_id = null;
    this.style = null;
    this.rule = null;
    this.legend = null;
  }
}
export { LegendSettings };
